import React from 'react';
import { Trans, useTrans } from 'base/utils/i18n';
import styles from './index.module.less';
import cn from 'classnames';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults';
import ResultsAddressForm from '@app/activity/testerClub/ResultsAddressForm';
import ResultsAddress from '@pro/activity/testerClub/ResultsContent/ResultsAddress';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import { isPhone } from 'base/utils/client';

type IProps = {
    results: IUseEarlyAccessResults
}

const ResultsInfoMsg: React.FC<IProps> = (props) => {
    const { t } = useTrans();

    const { results } = props
    const { resultsData } = results

    return (
        <>{resultsData?.userSelected ? (
            <div className={cn(
                styles['results-msg'],
                styles['selected'],
            )}>
                <h3 className={styles.title}>{t('web_common_congratulations')}</h3>
                <p className={styles.msg}>{t('web_shop_activity_early_access_result_selected1')}</p>
                <p className={styles.msg}>{t('web_shop_activity_early_access_result_selected2')}</p>

                {resultsData.userHasAddAddress ? (
                    <ResultsAddress address={resultsData.address}/>
                ) : (
                    <ResultsAddressForm results={results}/>
                )}

                {!!resultsData?.orderId &&
                    ((+resultsData.orderId) != 0) && (
                        <div>
                            <h3 className={styles['sub-title']}>
                                {t('web_early_access_order_created')}
                            </h3>
                            <div className={styles.msg}>
                                <p>{t('web_order_order_no')} #{resultsData.orderId} </p>
                                <Trans
                                    i18nKey="web_early_access_check_order"
                                    components={{
                                        ordersLink: (
                                            <a target={isPhone ? '_self' : '_blank'}
                                               href={generatePath(RouteEnum.ORDERS)}
                                               rel="noreferrer"
                                            />
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    )}

            </div>
        ) : (
            <div className={cn(
                styles['results-msg'],
                styles['unselected']
            )}>
                <h3 className={styles.title}>{t('web_shop_activity_early_access_result_unselected1')}</h3>
                <p className={styles.msg}>{t('web_shop_activity_early_access_result_unselected2')}</p>
                <p className={styles.msg}>{t('web_shop_activity_early_access_result_unselected3')}</p>
            </div>
        )}
        </>
    );
};

export default ResultsInfoMsg